import { createAction } from '@reduxjs/toolkit';

import { AnyApi } from './buildCreateApi';

export const resetAllApisState = /* @__PURE__ */ createAction('@@modules/testing/resetAllApisState');

/**
 * Добавляет в стор внутренний экшен для сброса состояния всех RTK Query API сразу.
 */
export function resetAllApisMiddleware(api: AnyApi): AnyApi['middleware'] {
    return mwApi => next => {
        return action => {
            if (resetAllApisState.match(action)) {
                mwApi.dispatch(api.util.resetApiState());
            }

            return next(action);
        };
    };
}
